import { createClient } from '@supabase/supabase-js';

const supabaseUrl = 'https://iwkcmdxpckxpzzsezcri.supabase.co'; // ← הדבק את שלך
const supabaseAnonKey = 'sb_publishable_ubu-pP0PT6n2dXOWmy8KyA_8mhV2hZX';      // ← הדבק את שלך

export const supabase = createClient(
  supabaseUrl,
  supabaseAnonKey
);
